<template>
      <div class="container pb-4 mb-4">
      <div class="row justify-content-center">
        <div class="col">
      
        <div class="row pb-2">
          <div class="col text-center">
            <h5>Sales</h5>
          </div>
        </div>

      <div v-if="sales == 0">
        <div class="card">
          <div class="card-body text-center">
            <div>You have no sales</div>  
          </div>  
        </div>      
      </div>

      <b-card v-else no-body>
        <b-tabs v-model="tabIndex" card align="center">
          <b-tab title="Create shipping label" title-link-class="darklink">
            <b-card-text>
              <admin-sales-list status="create shipping label"></admin-sales-list>
            </b-card-text>
          </b-tab>
          <b-tab title="Ready for collection" title-link-class="darklink">
            <b-card-text>
              <admin-sales-list status="ready for collection"></admin-sales-list>
            </b-card-text>
          </b-tab>
          <b-tab title="In transit" title-link-class="darklink">
            <b-card-text>
              <admin-sales-list status="in transit"></admin-sales-list>
            </b-card-text>
          </b-tab>
          <b-tab title="Delivered" title-link-class="darklink">
            <b-card-text>
              <admin-sales-list status="delivered"></admin-sales-list>
            </b-card-text>
          </b-tab>
          <b-tab title="Cancelled" title-link-class="darklink">
            <b-card-text>
              <admin-sales-list status="cancelled"></admin-sales-list>
            </b-card-text>
          </b-tab>
          <b-tab title="Other" title-link-class="darklink">
            <b-card-text>
              <admin-sales-list status="other"></admin-sales-list>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>

      </div>
    </div>
  </div>
</template> 

<script>
export default {
  props: ['sales'],

  data() {
    return {
      tabIndex: 0,
    };
  },

  created() {

  },

  methods: {

  }

}
</script>